import { React } from 'react'
import {NavLink} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb, faIdBadge, faUsers, faUser, faUserGear, faLock, faGear, faKey, faMobile, faListCheck, faArrowRightFromBracket, faCircleQuestion, faSquareTerminal, faWifi, faMessageExclamation } from '@fortawesome/pro-light-svg-icons';
import { endKeycloakSession } from '../components/auth/signOut';
import {useFeatureContext} from '../lib/context/featureContext';
import {Can} from '../components/auth/can';

const SideNav = (props) => {
  const {feature_subscriptions, feature_whitelist, feature_hdm_keys, feature_end_user_messaging} = useFeatureContext();
  return (
    <div className="side-nav" data-testid="side-nav">
      <div className="side-nav-section">
        <span className="side-nav-header">
          Monitoring
        </span>

        <NavLink end to="/">
          <FontAwesomeIcon icon={faLightbulb} size="lg" fixedWidth/>
          <span data-testid="dashboard-nav" className="nav-link-text">Dashboard</span>
        </NavLink>
      </div>
      
      <div className="side-nav-section">
        <span className="side-nav-header">
          Management
        </span>

        <Can code="USER_VIEW">
          <NavLink to="/users">
            <FontAwesomeIcon icon={faUsers} size="lg" fixedWidth/>
            <span data-testid="users-nav" className="nav-link-text">Users</span>
          </NavLink>
        </Can>

        <Can code="SAFECASE_VIEW">
          <NavLink to="/devices">
            <FontAwesomeIcon icon={faMobile} size="lg" fixedWidth/>
            <span data-testid="safecases-nav" className="nav-link-text">SafeCases</span>
          </NavLink>
        </Can>

        <Can code="HDM_PROFILE_VIEW">
          <NavLink to="/hdm-configuration">
            <FontAwesomeIcon icon={faGear} size="lg" fixedWidth/>
            <span data-testid="hdm-nav" className="nav-link-text">HDM Profiles</span>
          </NavLink>
        </Can>

        <Can code="POLICY_VIEW">
          <NavLink to="/policies">
            <FontAwesomeIcon icon={faListCheck} size="lg" fixedWidth/>
            <span data-testid="policies-nav" className="nav-link-text">Policies</span>
          </NavLink>
        </Can>

        {feature_whitelist &&
          <Can code="SSID_LIST_VIEW">
            <NavLink to="/ssid-whitelist">
              <FontAwesomeIcon icon={faWifi} size="lg" fixedWidth/>
              <span data-testid="ssid-whitelist-nav" className="nav-link-text">Wi-Fi SSID Lists</span>
            </NavLink>
          </Can>
        }

        {feature_end_user_messaging &&
          <Can code="ALERT_MSG_VIEW">
            <NavLink to="/messaging">
              <FontAwesomeIcon icon={faMessageExclamation} size="lg" fixedWidth/>
              <span data-testid="messaging-nav" className="nav-link-text">Messaging</span>
            </NavLink>
          </Can>
        }
        
      </div>

      <div className="side-nav-section">
        <span className="side-nav-header">
          Administration
        </span>

        {/* No permission listed for Account in the RBAC sheet - left ungated pending clarification */}
        <NavLink to="/account">
          <FontAwesomeIcon icon={faUserGear} size="lg" fixedWidth/>
          <span data-testid="account-nav" className="nav-link-text">Account</span>
        </NavLink>

        {/* <NavLink to="/bulk-operations"> */}
        {/*   <FontAwesomeIcon icon={faGear} size="lg" fixedWidth/> */}
        {/*   <span data-testid="bulk-nav" className="nav-link-text">Bulk Operations</span> */}
        {/* </NavLink> */}

        <Can code="CA_VIEW">
          <NavLink to="/admin">
            <FontAwesomeIcon icon={faUser} size="lg" fixedWidth/>
            <span data-testid="admin-nav" className="nav-link-text">Administrators</span>
          </NavLink>
        </Can>

        <Can code="ROLE_VIEW">
          <NavLink to="/roles">
            <FontAwesomeIcon icon={faIdBadge} size="lg" fixedWidth/>
            <span data-testid="roles-nav" className="nav-link-text">Roles</span>
          </NavLink>
        </Can>

        <Can code="LOGS_VIEW">
          <NavLink to="/logs">
            <FontAwesomeIcon icon={faSquareTerminal} size="lg" fixedWidth/>
            <span data-testid="logs-nav" className="nav-link-text">Logs</span>
          </NavLink>
        </Can>

        {/* No permission listed for Subscriptions in the RBAC sheet - left feature-flag-only */}
        {feature_subscriptions &&
          <NavLink to="/subscriptions">
            <FontAwesomeIcon icon={faLock} size="lg" fixedWidth/>
            <span data-testid="subscriptions-nav" className="nav-link-text">Subscriptions</span>
          </NavLink>
        }

        {/* No permission listed for HDM Keys in the RBAC sheet - left feature-flag-only */}
        {feature_hdm_keys &&
          <NavLink to="/hdm-keys">
            <FontAwesomeIcon icon={faKey} size="lg" fixedWidth/>
            <span data-testid="hdm-keys-nav" className="nav-link-text">HDM Keys</span>
          </NavLink>
        }

        <a className="pointer logout" onClick={e => endKeycloakSession("NavLink")}>
          <FontAwesomeIcon icon={faArrowRightFromBracket} size="lg" fixedWidth/>
          <span data-testid="logout-nav" className="nav-link-text">Sign Out</span>
        </a>
      </div>
    </div>
  )
}

export default SideNav;
